import React from 'react'

function Map() {
  return (
    <div>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.0432900125843!2d7.467154909280291!3d9.059815988470978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b1ab5e16c05%3A0x8bd3047109e0b4ba!2s8%20Mano%20Cl%2C%20Wuse%20904101%2C%20Abuja%2C%20Federal%20Capital%20Territory!5e0!3m2!1sen!2sng!4v1681856291031!5m2!1sen!2sng" className='w-full h-[70vh] ' allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="goggle-maps"></iframe>
    </div>
  )
}

export default Map
